module.exports = __webpack_public_path__ + "img/your-needs.1cb06f81.png";